module.exports = __webpack_public_path__ + "img/electricity.11c645e6.svg";